<!--
약관동의 컴포넌트
--------------------------
기능:
    - 전체 약관동의 / 개별 동의 체크박스 상태 관리
    - 아코디언 약관 본문 토글
    - 전체동의 시 본문 접기
    - 전체 동의 전까지 가입 버튼 비활성화

사용:
    <app-register-terms-agree
        action="/users/register-agree"
        csrf-token="{{ csrf_token() }}"
        :terms="[...]"
    >
        <template slot="content-0">약관1 HTML</template>
        <template slot="content-1">약관2 HTML</template>
        <template slot="content-2">약관3 HTML</template>
    </app-register-terms-agree>
-->
<template>
    <form method="post"
          :action="action"
          @submit.prevent="onSubmit"
    >
        <input type="hidden" name="_token" :value="csrfToken">

        <div class="uk-width-xxlarge@l uk-width-1-1 uk-align-center">

            <!-- 전체 약관동의 -->
            <div class="uk-card uk-card-default uk-margin-bottom" style="border: 2px solid #1e87f0;">
                <label class="uk-card-header uk-flex uk-flex-middle uk-margin-remove" style="padding: 1rem 1.5rem; background: #f0f7ff; cursor: pointer; display: flex;">
                    <input
                        class="uk-checkbox"
                        style="width: 24px; height: 24px; min-width: 24px;"
                        type="checkbox"
                        :checked="allAgreed"
                        @change="toggleAll"
                    >
                    <span class="uk-text-large uk-margin-small-left uk-text-bold">전체 약관동의</span>
                </label>
            </div>

            <!-- 개별 약관 -->
            <div v-for="(term, index) in terms"
                 :key="index"
                 class="uk-card uk-card-default uk-margin-bottom"
            >
                <div class="uk-card-header uk-flex uk-flex-between uk-flex-middle" style="padding: 0.75rem 1.5rem;">
                    <label class="uk-flex uk-flex-middle uk-margin-remove" style="cursor: pointer;">
                        <input
                            class="uk-checkbox"
                            type="checkbox"
                            :name="term.name"
                            value="yes"
                            v-model="agreed[index]"
                        >
                        <span class="uk-margin-small-left">{{ term.agreeText }}</span>
                        <span v-if="term.initError" class="uk-text-danger uk-margin-small-left">{{ term.initError }}</span>
                    </label>
                    <a class="uk-link-muted" href="#" style="white-space: nowrap;" @click.prevent="toggle(index)">
                        {{ expanded[index] ? '접기' : '내용 보기' }}
                        <span :uk-icon="'icon: chevron-' + (expanded[index] ? 'up' : 'down') + '; ratio: 0.8'"></span>
                    </a>
                </div>
                <transition name="slide">
                    <div v-show="expanded[index]" class="uk-card-body" style="padding: 0 1.5rem 1.25rem;">
                        <h5 class="uk-text-bold uk-margin-small-bottom">{{ term.title }}</h5>
                        <div class="uk-height-max-medium uk-overflow-auto uk-padding-small" style="border: 1px solid #e5e5e5; border-radius: 4px; background: #fafafa; white-space: pre-wrap; font-size: 1rem; line-height: 1.6;">{{ term.content }}</div>
                    </div>
                </transition>
            </div>

            <!-- 가입 버튼 -->
            <div class="uk-text-center uk-margin-top uk-margin-large-bottom">
                <button type="submit"
                        :disabled="!allAgreed"
                        :style="{
                            display: 'inline-block',
                            minWidth: '360px',
                            padding: '18px 48px',
                            fontSize: '1.35rem',
                            fontWeight: '600',
                            letterSpacing: '0.04em',
                            border: 'none',
                            borderRadius: '12px',
                            color: '#fff',
                            background: allAgreed ? 'linear-gradient(135deg, #1e87f0, #0f6dd6)' : '#ccc',
                            boxShadow: allAgreed ? '0 4px 14px rgba(30,135,240,0.35)' : 'none',
                            cursor: allAgreed ? 'pointer' : 'not-allowed',
                            transition: 'all 0.3s ease',
                        }"
                >
                    <span uk-icon="icon: check; ratio: 1.2"></span> 동의하며 가입하기
                </button>
            </div>

        </div>
    </form>
</template>

<script>
export default {
    props: {
        action: { type: String, required: true },
        csrfToken: { type: String, required: true },
        terms: { type: Array, required: true },
    },

    data: function () {
        var agreed = [];
        var expanded = [];
        for (var i = 0; i < this.terms.length; i++) {
            agreed.push(this.terms[i].initChecked || false);
            expanded.push(false);
        }
        return {
            agreed: agreed,
            expanded: expanded,
        };
    },

    computed: {
        allAgreed: function () {
            for (var i = 0; i < this.agreed.length; i++) {
                if (!this.agreed[i]) return false;
            }
            return true;
        },
    },

    methods: {
        toggleAll: function (e) {
            var checked = e.target.checked;
            for (var i = 0; i < this.agreed.length; i++) {
                this.$set(this.agreed, i, checked);
            }
            // 전체동의 시 열린 본문 접기
            if (checked) {
                for (var j = 0; j < this.expanded.length; j++) {
                    this.$set(this.expanded, j, false);
                }
            }
        },

        toggle: function (index) {
            this.$set(this.expanded, index, !this.expanded[index]);
        },

        onSubmit: function () {
            if (!this.allAgreed) return;
            this.$el.submit();
        },
    },
};
</script>
